export function parseFormToJson($form){
    var serialized = $form.serializeArray();
    var s;
    var data = {};

    for (s in serialized){
        data[serialized[s]['name']] = serialized[s]['value'];
    }
    return data;
}
